import { cx } from '@shared/lib/cx'
import { option, root } from './SegmentedControl.css'

export type SegmentedOption<T extends string> = {
  value: T
  label: string
}

export type SegmentedControlProps<T extends string> = {
  value: T
  options: ReadonlyArray<SegmentedOption<T>>
  onChange: (value: T) => void
  ariaLabel?: string
  className?: string
  disabled?: boolean
}

export function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
  className,
  disabled = false,
}: SegmentedControlProps<T>) {
  return (
    <div
      className={cx(root, className)}
      role="tablist"
      aria-label={ariaLabel}
      data-disabled={disabled ? 'true' : undefined}
    >
      {options.map((item) => {
        const active = item.value === value
        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            className={option({ active })}
            onClick={() => {
              if (disabled) return
              onChange(item.value)
            }}
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
